import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public transform(values: any[], field: string | [], value: any, equals: boolean = true, startsWith: boolean = false): any[] {
        if (values === null || values === undefined) {
            return [];
        }

        if (!(value instanceof Array)) {
            value = [ value ];
        } else if (value.length === 0) {
            return values;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return values.filter((val: any) => {
            let found: boolean = false;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const foundVal: any = (field === null || field === undefined) ? val : this.getValue(val, field);
            for (const filterVal of value) {
                if (!startsWith ? foundVal === filterVal : !!foundVal?.startsWith(filterVal)) {
                    found = true;
                }
            }
            return equals ? found : !found;
        });

    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getValue<T>(data: T, key: string | string[]): any {
        let keys: string[];
        if (!(key instanceof Array)) {
            keys = [ key ];
        } else {
            keys = key;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let res: any = data;
        for (const realKey of keys) {
            res = res[ realKey ];
        }
        return res;
    }

}
